import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { ListResultDTO } from '../../../helpers/listResult.interface copy';
import { NotificationsDTO, NotificationsFilters } from '../../models/notifications';

@Injectable({
    providedIn: 'root',
})
export class LaravelNotificationsService {
    constructor(private httpClient: HttpClient) {}

    private get ROUTES() {
        return {
            list: environment.baseUrl + '/api/notifications',
            show: environment.baseUrl + '/api/notifications',
            store: environment.baseUrl + '/api/notifications',
            destroy: environment.baseUrl + '/api/notifications',
        };
    }

    public list(
        page: number,
        per_page: number,
        order: string,
        direction: string,
        filters: NotificationsFilters,
        includes?: string[]
    ): Observable<ListResultDTO<NotificationsDTO>> {
        let params = {};

        if (page) params["page"] = "" + page;
        if (per_page) params["per_page"] = "" + per_page;
        if (order) params["order"] = "" + order;
        if (direction) params["direction"] = "" + direction;
        if (includes) params["includes[]"] = includes;
        if (filters) {
            if (filters.title) params['title'] = filters.title;

            if (filters.tenant_id) params["tenant_id"] = "" + filters.tenant_id;            
        }
        
        if (per_page) {
            params['per_page'] = '' + per_page;
            if (page) params['page'] = '' + page;
            return this.httpClient.get<ListResultDTO<NotificationsDTO>>(
            this.ROUTES.list,
            {
                params: new HttpParams({ fromObject: params }),
            }
            );
        } else {
            return this.httpClient
            .get<NotificationsDTO[]>(this.ROUTES.list, {
                params: new HttpParams({ fromObject: params }),
            })
            .pipe(
                map((results) => {
                return {
                    data: results,
                    total: results.length,
                };
                })
            );
        }
    }

    public show(id: number): Observable<NotificationsDTO> {
    let params = { id: '' + id };
    return this.httpClient.get<NotificationsDTO>(this.ROUTES.show, {
        params: new HttpParams({
        fromObject: params,
        }),
    });
    }

    public upsert(notification: NotificationsDTO): Observable<NotificationsDTO> {
        if (notification.id) {
            return this.httpClient.put<NotificationsDTO>(`${this.ROUTES.store}/${notification.id}`, {
                ...notification,
            });
        } else {
            return this.httpClient.post<NotificationsDTO>(`${this.ROUTES.store}`, {
                ...notification,
            });
        }
    }

    public delete(id: number) {
    let params = new HttpParams().set("id", "" + id);
    return this.httpClient.delete(this.ROUTES.destroy + "/" + id);
    }

    public sendNotification(id: number): Observable<any> {
        if (!id) {
            console.error("Errore: l'ID della notifica è undefined!");
            return new Observable();
        }

        const url = `${this.ROUTES.show}/${id}/send`;
        return this.httpClient.patch(url, {});
    }
    

    // public sendNotification(id: number, send: boolean): Observable<any> {
    //     const url = `${this.ROUTES.show}/${id}/send`;
    //     return this.httpClient.patch(url, { send });
    // }
    
    

}